<template>
    <fieldset :disabled="disabled" class="benefit-fields">
        <legend>Benefit terms</legend>
        <div class="terms-grid">
            <label v-if="!kind">Benefit type
                <select :value="value.kind" @change="update('kind', $event.target.value)">
                    <option value="">Choose a benefit</option>
                    <option value="AMOUNT_OFF">Amount off merchandise</option>
                    <option value="PERCENT_OFF">Percentage off merchandise</option>
                    <option value="NON_STOCK">Non-stock entitlement</option>
                </select>
            </label>
            <label v-if="value.kind === 'AMOUNT_OFF'">Amount ($)
                <input :value="value.amount" type="number" min="0.01" step="0.01" @input="update('amount', $event.target.value)" />
            </label>
            <label v-if="value.kind === 'PERCENT_OFF'">Percentage
                <input :value="value.percent" type="number" min="0.01" max="100" step="0.01" @input="update('percent', $event.target.value)" />
            </label>
            <label v-if="isDiscount">Maximum discount ($)
                <input :value="value.cap" type="number" min="0.01" step="0.01" @input="update('cap', $event.target.value)" />
            </label>
            <label>Issued benefit expiry
                <select :value="value.expiry_mode" @change="update('expiry_mode', $event.target.value)">
                    <option value="FIXED">Fixed date</option>
                    <option value="DURATION">Duration from issuance</option>
                    <option v-if="!voucher" value="NONE">No expiry</option>
                </select>
            </label>
            <label v-if="value.expiry_mode === 'FIXED'">Expires (America/Toronto)
                <input :value="value.expires_at" type="datetime-local" @input="update('expires_at', $event.target.value)" />
            </label>
            <label v-if="value.expiry_mode === 'DURATION'">Days from issuance
                <input :value="value.duration_days" type="number" min="1" step="1" @input="update('duration_days', $event.target.value)" />
            </label>
            <label v-if="isDiscount">Full-refund handling
                <select :value="value.refund_policy" @change="update('refund_policy', $event.target.value)">
                    <option value="">Unconfigured — draft only</option>
                    <option value="KEEP_SPENT">Keep benefit spent</option>
                    <option value="RESTORE_ON_FULL_REFUND">Restore points or campaign voucher on full refund</option>
                </select>
            </label>
        </div>
        <label v-if="isDiscount">Eligible approved merchandise item codes (one per line or comma separated)
            <textarea :value="value.eligible_items" rows="3" @input="update('eligible_items', $event.target.value)"></textarea>
        </label>
        <p v-if="isDiscount">Single use, assigned to one customer, with no stacking. Eligibility and caps are checked at checkout.</p>
        <p v-else-if="value.kind === 'NON_STOCK'">Assigned to one customer for one staff-recorded fulfillment. No stock deduction.</p>
        <p v-if="value.expiry_mode === 'DURATION'">A day is exactly 24 hours from issuance. Campaign dates do not change an issued benefit's expiry.</p>
        <p>Point-lot expiry and the existing points valuation remain governed by the loyalty program.</p>
        <p v-if="isDiscount && value.refund_policy === 'RESTORE_ON_FULL_REFUND'">A full refund restores points to their original lots and expiry for a points-funded discount, or restores the same campaign voucher with its original expiry. Partial refunds do not restore benefits.</p>
    </fieldset>
</template>

<script>
import { newBenefitPolicyEditor } from "../../utils/loyalty-benefit-policy"

export default {
    props: { value: { type: Object, required: true }, kind: { type: String, default: "" }, disabled: Boolean, voucher: Boolean, newPolicy: Boolean },
    computed: { isDiscount() { return ["AMOUNT_OFF", "PERCENT_OFF"].includes(this.value.kind) } },
    methods: {
        update(field, value) {
            const edit = { ...this.value, [field]: value }
            if (this.newPolicy && field === "kind" && !this.isDiscount && ["AMOUNT_OFF", "PERCENT_OFF"].includes(value)) {
                edit.refund_policy = newBenefitPolicyEditor(value).refund_policy
            }
            this.$emit("input", edit)
        },
    },
}
</script>

<style scoped>
.benefit-fields { margin: 12px 0; padding: 12px; border: 1px solid #d5e4e1; border-radius: 8px; }
legend { font-size: 15px; font-weight: 700; color: #0b302c; }
.terms-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 12px; }
label { display: grid; gap: 5px; font-size: 13px; font-weight: 600; margin-bottom: 10px; }
input, select, textarea { width: 100%; border: 1px solid #d9dee3; border-radius: 6px; padding: 8px; background: white; }
p { color: #5f6368; font-size: 13px; margin: 6px 0; }
</style>
